// removed by extract-text-webpack-plugin
module.exports = {"featOffer":"src-components-OfferingList-___FeaturedOffering__featOffer___2YJx7","featVideoDesk":"src-components-OfferingList-___FeaturedOffering__featVideoDesk___2DxwO","featLabelDesk":"src-components-OfferingList-___FeaturedOffering__featLabelDesk___2Ojj2","featNameDesk":"src-components-OfferingList-___FeaturedOffering__featNameDesk___2Y1Rw","featLabelMob":"src-components-OfferingList-___FeaturedOffering__featLabelMob___3lq0N","featNameMob":"src-components-OfferingList-___FeaturedOffering__featNameMob___2kyTv"};


//////////////////
// WEBPACK FOOTER
// ./src/components/OfferingList/FeaturedOffering.css
// module id = 1059
// module chunks = 3